import { parsePriceToNumber } from './service';

export const priceSorter = (a, b) =>
  parsePriceToNumber(a) - parsePriceToNumber(b);
